var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.65 10.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #fff;\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-width: .75px;\n      }\n\n      .cls-3 {\n        fill: #0035ff;\n        stroke: #0035ff;\n        stroke-width: .25px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 4.68,
    cy: 6.28,
    r: 4.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.32.93c.83,2.21,2.45,3.19,3.41,3.6.24.1.21.42-.03.52-2.12.9-3.03,2.63-3.4,3.6-.08.22-.37.19-.45-.03-.83-2.21-2.45-3.19-3.41-3.6-.24-.1-.21-.42.03-.52,2.12-.9,3.03-2.63,3.4-3.6.08-.22.37-.19.45.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.32.93c.83,2.21,2.45,3.19,3.41,3.6.24.1.21.42-.03.52-2.12.9-3.03,2.63-3.4,3.6-.08.22-.37.19-.45-.03-.83-2.21-2.45-3.19-3.41-3.6-.24-.1-.21-.42.03-.52,2.12-.9,3.03-2.63,3.4-3.6.08-.22.37-.19.45.03Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.82259387153fb50bc80b09d5175862a5.svg";
export { ForwardRef as ReactComponent };